import React from "react";
import clsx from "clsx";
//import I18n from "i18n-js/index.js.erb"

class TaskManagerPresenterGeneral extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var tabClasses = clsx({
      active: this.props.active_tab == "general",
      "tab-pane": true,
    });

    return (
      <div className={tabClasses} id="general">
        <div className="row">
          <div className="col-md-12">{this.renderGeneralForm()}</div>
        </div>
      </div>
    );
  }

  renderGeneralForm() {
    return (
      <div>
        <div className="row" id="test">
          <div className="col-md-4">
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>{I18n.t("status")}</label>
              <br />
              <div>{I18n.t(this.props.status)}</div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>{I18n.t("time_period")} </label>
              <br />
              <div>{I18n.t(this.props.time_period.replace(/_at/g, ""))}</div>
            </div>
          </div>
          {this.props.time_period == "every_day_at" ? (
            <div className="col-md-4">
              <div className="form-group" style={{ marginBottom: 0 }}>
                <label>{I18n.t("time_value")} </label>
                <br />
                <div>{this.props.time_value}</div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default TaskManagerPresenterGeneral;
